import { ContractingStateEnum } from 'v3/data/store/contracting/enums';

export const ContractingStatusMap = {
  [ContractingStateEnum.ContractingStarted]: 'Contratação iniciada',
  [ContractingStateEnum.ContractingDenied]: 'Contratação negada',
  [ContractingStateEnum.ProcessingCreditAnalysis]: 'Processando análise de crédito',
  [ContractingStateEnum.CreditAnalysisRejected]: 'Análise de crédito reprovada',
  [ContractingStateEnum.WaitingProposalGeneration]: 'Aguardando geração de proposta',
  [ContractingStateEnum.WaitingDocuments]: 'Aguardando documentos',
  [ContractingStateEnum.WaitingSelfie]: 'Aguardando selfie',
  [ContractingStateEnum.CafRejected]: 'Caf reprovada',
  [ContractingStateEnum.WaitingRegistrationData]: 'Aguardando dados cadastrais',
  [ContractingStateEnum.CpfBlocked]: 'CPF bloqueado',
  [ContractingStateEnum.WaitingProposalAcceptance]: 'Aguardando aceite de proposta',
  [ContractingStateEnum.WaitingTermsAcceptance]: 'Aguardando aceite de termos',
  [ContractingStateEnum.ProcessingAntiFraud]: 'Análise de documento em andamento',
  [ContractingStateEnum.WaitingContractEffectiveness]: 'Aguardando efetivação de contrato',
  [ContractingStateEnum.ContractingFinished]: 'Contratação finalizada',
  [ContractingStateEnum.ExpiredKey]: 'Chave expirada',
};

export const getContractingStatusEnum = (title: string): ContractingStateEnum | undefined => {
  return Object.keys(ContractingStatusMap).find(
    (key) => ContractingStatusMap[key as keyof typeof ContractingStatusMap] === title,
  ) as ContractingStateEnum | undefined;
};
